//------------------------------------------------------------------------------
// This file is auto-generated.
//------------------------------------------------------------------------------
// This file was generated by NTypewriter from the C# ViewModel class with the
// same class/interface name.
//
// Do not change this file.  Any changes may cause incorrect behaviour and will
// be lost if the code is regenerated.
//------------------------------------------------------------------------------

import { ItemBase } from '../internal/ItemBase';
import { CalendarFeedFreeBusyMode } from './Enums';

export class TeacherCalendarFeedPreferencesDisplayItem extends ItemBase {
    AlertBeforeInMinutes: number = 0;
    FreeBusyEventMode: CalendarFeedFreeBusyMode = CalendarFeedFreeBusyMode.None;
    FutureMonthsToSynchronize: number = 0;
    PastMonthsToSynchronize: number = 0;
    ShowAllTeachers: boolean = false;
    SynchronizeBirthdays: boolean = false;
    SynchronizeRepertoirePerformances: boolean = false;
    EventCategoryIDsToAlert: string[] = [];

    constructor(initializer?: Partial<TeacherCalendarFeedPreferencesDisplayItem>) {
        super();
        if (initializer) {
            Object.assign(this, initializer);
        }
    }

    static readonly ClassName: string = "TeacherCalendarFeedPreferencesDisplayItem";
}
